<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bgc-{name}</code> to control which box an element's background is clipped by.</p>
<code-example source-code='&lt;div class=&quot;d-bgc-border-box d-p-200 d-bgc-moderate d-ba d-baw4 d-bas-dashed d-bar-400&quot;&gt;border-box&lt;/div&gt;
&lt;div class=&quot;d-bgc-padding-box d-p-200 d-bgc-moderate d-ba d-baw4 d-bas-dashed d-bar-400&quot;&gt;padding-box&lt;/div&gt;
&lt;div class=&quot;d-bgc-content-box d-p-200 d-bgc-moderate d-ba d-baw4 d-bas-dashed d-bar-400&quot;&gt;content-box&lt;/div&gt;'>
<dt-stack data-demo-wrapper direction="row" gap="400">
  <div class="d-bgc-border-box d-p-200 d-bgc-moderate d-ba d-baw4 d-bas-dashed d-bar-400">border-box</div>
  <div class="d-bgc-padding-box d-p-200 d-bgc-moderate d-ba d-baw4 d-bas-dashed d-bar-400">padding-box</div>
  <div class="d-bgc-content-box d-p-200 d-bgc-moderate d-ba d-baw4 d-bas-dashed d-bar-400">content-box</div>
</dt-stack>
</code-example>
<h2 id="clipping-text" tabindex="-1" class="d-docsite--header-2">Clipping Text <a class="header-anchor d-link d-docsite--link d-link" href="#clipping-text" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use <code v-pre>d-bgc-text</code> to clip the background color(s) within the foreground text.</p>
<code-example source-code='&lt;dt-text kind=&quot;headline&quot; :size=&quot;700&quot; class=&quot;d-ba d-bgc-text d-bgg-to-r d-bgg-from-magenta-500 d-bgg-to-purple-600&quot;&gt;Magic stuff happens.&lt;/dt-text&gt;'>
<dt-text kind="headline" :size="700" class="d-ba d-bgc-text d-bgg-to-r d-bgg-from-magenta-500 d-bgg-to-purple-600">Magic stuff happens.</dt-text>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
        <tr v-for="i in ['unset', 'border-box', 'padding-box', 'content-box', 'text']">
          <th scope="row" class="d-code--sm d-docsite-code">.d-bgc-{{ i }}</th>
          <td class="d-code--sm">background-clip: {{ i }} !important;</td>
        </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


